import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BundleRequest,
  BundleResponse,
  BundleListResponse,
  BundleListParams,
  BundleDetails,
  BundleProductsResponse,
} from '../../pages/admin-dashboard/promotions/bundles-managment/bundles.model';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth-service';

@Injectable({
  providedIn: 'root',
})
export class BundleService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);
  private apiUrl = `${environment.productsApiUrl}/bundles`;

  private get authHeaders() {
    const token = this.authService.getAccessToken();
    return { Authorization: `Bearer ${token}` };
  }

  createBundle(bundleData: BundleRequest): Observable<BundleResponse> {
    return this.http.post<BundleResponse>(this.apiUrl, bundleData, {
      headers: this.authHeaders,
    });
  }

  getBundles(params: BundleListParams = {}): Observable<BundleListResponse> {
    let httpParams = new HttpParams();

    if (params.pageNum !== undefined) httpParams = httpParams.set('pageNum', params.pageNum);
    if (params.pageSize !== undefined) httpParams = httpParams.set('pageSize', params.pageSize);
    if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy);
    if (params.orderDir) httpParams = httpParams.set('orderDir', params.orderDir);
    if (params.title) httpParams = httpParams.set('title', params.title);
    if (params.startDateFrom) httpParams = httpParams.set('startDateFrom', params.startDateFrom);
    if (params.startDateTo) httpParams = httpParams.set('startDateTo', params.startDateTo);
    if (params.endDateFrom) httpParams = httpParams.set('endDateFrom', params.endDateFrom);
    if (params.endDateTo) httpParams = httpParams.set('endDateTo', params.endDateTo);
    if (params.status?.length) {
      params.status.forEach((s) => (httpParams = httpParams.append('status', s)));
    }
    if (params.discountTypes?.length) {
      params.discountTypes.forEach((d) => (httpParams = httpParams.append('discountTypes', d)));
    }

    return this.http.get<BundleListResponse>(this.apiUrl, {
      headers: this.authHeaders,
      params: httpParams,
    });
  }

  getBundleById(bundleId: string): Observable<BundleDetails> {
    return this.http.get<BundleDetails>(`${this.apiUrl}/${bundleId}`, {
      headers: this.authHeaders,
    });
  }

  getBundleProducts(bundleId: string): Observable<BundleProductsResponse> {
    return this.http.get<BundleProductsResponse>(`${this.apiUrl}/${bundleId}/items`, {
      headers: this.authHeaders,
    });
  }
  deleteBundle(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, {
      headers: this.authHeaders,
    });
  }

  activateBundle(id: string): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${id}/activate`, {}, { headers: this.authHeaders });
  }

  deactivateBundle(id: string): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${id}/deactivate`, {}, { headers: this.authHeaders });
  }

  getOneCustomerBundle(bundleId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/public/${bundleId}`, { headers: this.authHeaders });
  }
}
